import React, { useEffect, useRef, useState } from 'react';

/**
 * TypingMessage
 *
 * Renders `content` character-by-character at `speed` ms/char.
 * Calls `onDone` when the full text has been rendered.
 * Displays a blinking cursor while typing.
 */
const TypingMessage = ({ content, speed = 12, className = '', onDone }) => {
  const [displayed, setDisplayed] = useState('');
  const [done, setDone] = useState(false);
  const indexRef = useRef(0);

  useEffect(() => {
    setDisplayed('');
    setDone(false);
    indexRef.current = 0;

    if (!content) {
      setDone(true);
      onDone?.();
      return;
    }

    const interval = setInterval(() => {
      indexRef.current += 1;
      setDisplayed(content.slice(0, indexRef.current));
      if (indexRef.current >= content.length) {
        clearInterval(interval);
        setDone(true);
        onDone?.();
      }
    }, speed);

    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);

  return (
    <span className={className}>
      {displayed}
      {!done && (
        <span className="inline-block w-[2px] h-[1em] bg-current opacity-60 animate-pulse ml-[1px] align-text-bottom" />
      )}
    </span>
  );
};

export default TypingMessage;
